<template>
  <section
    class="border-grey flex flex-col rounded-lg border p-4 xl:p-6"
    data-testid="dashboard-item"
  >
    <slot />
  </section>
</template>
